import {industryTranslations as labels} from './translations';
import {GroupSuggestions} from './types';
import {TermDescriptor} from '@planday-corp/globalization';
import {Option} from '@planday-corp/ui/types';
import {EnforcedLanguageSetting} from '~/App/context';

export const SHOW_TEAM_STEP = Boolean(
  window?.location?.search?.includes('showTeamStep')
);

interface IndustryDropdownGroup {
  label: TermDescriptor;
  isTitle: boolean;
  items: Option<string>[];
}

export const industry: IndustryDropdownGroup[] = [
  {
    label: labels.hospitality.hospitality,
    isTitle: true,
    items: [
      {
        label: labels.hospitality.hotels,
        value: 'Hotels',
      },
      {
        label: labels.hospitality.cafeRestaurant,
        value: 'Café & Restaurant',
      },
      {
        label: labels.hospitality.barPubNightclub,
        value: 'Bar, Pub & Nightclub',
      },
      {
        label: labels.hospitality.cateringCanteen,
        value: 'Catering & Canteen',
      },
    ],
  },
  {
    label: labels.retail.retail,
    isTitle: true,
    items: [
      {
        label: labels.retail.retailStore,
        value: 'Retail Store',
      },
      {
        label: labels.retail.bakery,
        value: 'Bakery',
      },
      {
        label: labels.retail.barberShopsBeautySalons,
        value: 'Barber Shops & Beauty Salons',
      },
    ],
  },
  {
    label: labels.professionalServices.professionalServices,
    isTitle: true,
    items: [
      {
        label: labels.professionalServices.realEstate,
        value: 'Real Estate',
      },
      {
        label: labels.professionalServices.cleaningServices,
        value: 'Cleaning Services',
      },
      {
        label: labels.professionalServices.security,
        value: 'Security',
      },
      {
        label: labels.professionalServices.staffingAndRecruiting,
        value: 'Staffing and Recruiting',
      },
      {
        label: labels.professionalServices.callCenterTelemarketing,
        value: 'Call Center & Telemarketing',
      },
      {
        label:
          labels.professionalServices.facilitiesManagementCommercialCleaning,
        value: 'CommercialFacilities Management & Cleaning',
      },
    ],
  },
  {
    label: labels.entertainmentLeisure.entertainmentLeisure,
    isTitle: true,
    items: [
      {
        label: labels.entertainmentLeisure.entertainmentCinemasFunParks,
        value: 'Entertainment, Cinemas & Fun Parks',
      },
      {
        label: labels.entertainmentLeisure.eventsEventManagement,
        value: 'Events & Event Management',
      },
      {
        label: labels.entertainmentLeisure.museumsAndInstitutions,
        value: 'Museums and Institutions',
      },
      {
        label: labels.entertainmentLeisure.performingArts,
        value: 'Performing Arts',
      },
    ],
  },
  {
    label: labels.healthcareMedical.healthcareMedical,
    isTitle: true,
    items: [
      {
        label: labels.healthcareMedical.elderlyCareServices,
        value: 'Elderly Care Services',
      },
      {
        label: labels.healthcareMedical.dentalOffices,
        value: 'Dental Offices',
      },
      {
        label: labels.healthcareMedical.hospitalsClinics,
        value: 'Hospitals & Clinics',
      },
      {
        label: labels.healthcareMedical.drugStoresPharmacies,
        value: 'Drug Stores & Pharmacies',
      },
      {
        label: labels.healthcareMedical.veterinaryServices,
        value: 'Veterinary Services',
      },
    ],
  },
  {
    label: labels.wellnessFitness.wellnessFitness,
    isTitle: true,
    items: [
      {
        label: labels.wellnessFitness.fitnessDanceFacilities,
        value: 'Fitness & Dance Facilities',
      },
      {
        label: labels.wellnessFitness.sports,
        value: 'Sports',
      },
    ],
  },
  {
    label: labels.education.education,
    isTitle: true,
    items: [
      {
        label: labels.education.collegesUniversities,
        value: 'Colleges & Universities',
      },
      {
        label: labels.education.primarySecondaryEducation,
        value: 'Primary or Secondary Education',
      },
      {
        label: labels.education.childcare,
        value: 'Childcare',
      },
    ],
  },
  {
    label: labels.finance.finance,
    isTitle: true,
    items: [
      {
        label: labels.finance.accounting,
        value: 'Accounting',
      },
      {
        label: labels.finance.insurance,
        value: 'Insurance',
      },
      {
        label: labels.finance.banking,
        value: 'Banking',
      },
    ],
  },

  {
    label: labels.mediaCommunications.mediaCommunications,
    isTitle: true,
    items: [
      {
        label: labels.mediaCommunications.advertising,
        value: 'Advertising',
      },
      {
        label: labels.mediaCommunications.media,
        value: 'Media',
      },
      {
        label: labels.mediaCommunications.press,
        value: 'Press',
      },
    ],
  },

  {
    label: labels.transportation.transportation,
    isTitle: true,
    items: [
      {
        label: labels.transportation.logisticsAndSupplyChain,
        value: 'Logistics and Supply Chain',
      },
      {
        label: labels.transportation.warehousing,
        value: 'Warehousing',
      },
      {
        label: labels.transportation.transportation,
        value: 'Transportation',
      },
    ],
  },
  {
    label: labels.softwareITServices.softwareITServices,
    isTitle: true,
    items: [
      {
        label: labels.softwareITServices.software,
        value: 'Software',
      },
    ],
  },
  {
    label: labels.other.other,
    isTitle: true,
    items: [
      {
        label: labels.other.construction,
        value: 'Construction',
      },
      {
        label: labels.other.manufacturing,
        value: 'Manufacturing',
      },
      {
        label: labels.other.municipality,
        value: 'Municipality',
      },
      {
        label: labels.other.nonProfitCharitableOrganizations,
        value: 'Non-Profit & Charitable Organizations',
      },
      {
        label: labels.other.other,
        value: 'Other',
      },
    ],
  },
];

export const noOfEmployees = [
  {
    label: '1-9',
    value: '1-9',
  },
  {
    label: '10-19',
    value: '10-19',
  },
  {
    label: '20-29',
    value: '20-29',
  },
  {
    label: '30-39',
    value: '30-39',
  },
  {
    label: '40-49',
    value: '40-49',
  },
  {
    label: '50-99',
    value: '50-99',
  },
  {
    label: '100-249',
    value: '100-249',
  },
  {
    label: '250+',
    value: '250+',
  },
];

export const SUPPORTED_LANGUAGES = [
  'en',
  'da',
  'sv',
  'no',
  'de',
  'fr',
  'it',
  'es',
];

export const langToLocaleDict: Record<
  (typeof SUPPORTED_LANGUAGES)[number],
  EnforcedLanguageSetting
> = {
  en: 'en-GB',
  da: 'da-DK',
  sv: 'sv-SE',
  no: 'nb-NO',
  de: 'de-DE',
  fr: 'fr-FR',
  it: 'it-IT',
  es: 'es-ES',
};

export const TRACKING_QUERY_PARAMS = [
  'gclid',
  'gaid',
  'utm_campaign',
  'utm_source',
  'utm_medium',
  'entryReferrerUrl',
];

/**
 * 
    "Czech": 14,
    "Danish": 1,
    "German": 6,
    "Greek": 15,
    "English": 2,
    "Spanish": 11,
    "Finnish": 16,
    "French": 9,
    "Italian": 10,
    "Japanese": 17,
    "Dutch": 12,
    "Norwegian": 4,
    "Polish": 8,
    "Swedish": 5,
    "Thai": 22,
    "English_UK": 19,
    "Portuguese": 13,
    "Chinese_SG": 21
 */

export const ENGLISH_UK_LANGUAGE_ID = 19;

export const MOBILE_BREAKPOINT = 480;

export const TABLET_BREAKPOINT = 1023;

export const groupSuggestions: GroupSuggestions[] = [
  {
    industry: 'Bar, Pub & Nightclub',
    groups: [
      {term: 'SimpleOnboarding.Role_Bartender', fallback: 'Bartender'},
      {term: 'SimpleOnboarding.Role_Manager', fallback: 'Manager'},
      {term: 'SimpleOnboarding.Role_Barback', fallback: 'Barback'},
      {term: 'SimpleOnboarding.Role_Cleaner', fallback: 'Cleaner'},
      {term: 'SimpleOnboarding.Role_Runner', fallback: 'Runner'},
      {term: 'SimpleOnboarding.Role_Cloakroom', fallback: 'Cloakroom'},
      {term: 'SimpleOnboarding.Role_Host', fallback: 'Host'},
    ],
  },
  {
    industry: 'Café & Restaurant',
    groups: [
      {term: 'SimpleOnboarding.Role_Barista', fallback: 'Barista'},
      {term: 'SimpleOnboarding.Role_Manager', fallback: 'Manager'},
      {term: 'SimpleOnboarding.Role_Server', fallback: 'Server'},
      {term: 'SimpleOnboarding.Role_SousChef', fallback: 'Sous chef'},
      {term: 'SimpleOnboarding.Role_LineCook', fallback: 'Line cook'},
      {term: 'SimpleOnboarding.Role_Host', fallback: 'Host'},
      {term: 'SimpleOnboarding.Role_Sommelier', fallback: 'Sommelier'},
      {term: 'SimpleOnboarding.Role_Dishwasher', fallback: 'Dishwasher'},
    ],
  },
  {
    industry: 'Call Center & Telemarketing',
    groups: [
      {term: 'SimpleOnboarding.Role_Sales', fallback: 'Sales'},
      {
        term: 'SimpleOnboarding.Role_CustomerServiceRepresentative',
        fallback: 'Customer Service Representative',
      },
      {term: 'SimpleOnboarding.Role_Supervisor', fallback: 'Supervisor'},
      {term: 'SimpleOnboarding.Role_TeamLeader', fallback: 'Team Leader'},
      {
        term: 'SimpleOnboarding.Role_TrainingSpecialist',
        fallback: 'Training specialist',
      },
      {term: 'SimpleOnboarding.Role_Telemarketer', fallback: 'Telemarketer'},
      {term: 'SimpleOnboarding.Role_Agent', fallback: 'Agent'},
    ],
  },
  {
    industry: 'Catering & Canteen',
    groups: [
      {term: 'SimpleOnboarding.Role_Chef', fallback: 'Chef'},
      {term: 'SimpleOnboarding.Role_Server', fallback: 'Server'},
      {term: 'SimpleOnboarding.Role_Porters', fallback: 'Porters'},
      {term: 'SimpleOnboarding.Role_Potwash', fallback: 'Potwash'},
      {
        term: 'SimpleOnboarding.Role_DeliveryDriver',
        fallback: 'Delivery driver',
      },
      {
        term: 'SimpleOnboarding.Role_CateringManager',
        fallback: 'Catering manager',
      },
      {term: 'SimpleOnboarding.Role_MenuPlanner', fallback: 'Menu planner'},
      {term: 'SimpleOnboarding.Role_PastryChef', fallback: 'Pastry chef'},
    ],
  },
  {
    industry: 'Entertainment, Cinemas & Fun Parks',
    groups: [
      {term: 'SimpleOnboarding.Role_Cashier', fallback: 'Cashier'},
      {term: 'SimpleOnboarding.Role_Security', fallback: 'Security'},
      {term: 'SimpleOnboarding.Role_Manager', fallback: 'Manager'},
      {
        term: 'SimpleOnboarding.Role_BoxOfficeAttendant',
        fallback: 'Box Office Attendant',
      },
      {term: 'SimpleOnboarding.Role_Usher', fallback: 'Usher'},
      {term: 'SimpleOnboarding.Role_Cleaner', fallback: 'Cleaner'},
    ],
  },
  {
    industry: 'Events & Event Management',
    groups: [
      {
        term: 'SimpleOnboarding.Role_BoxOfficeManager',
        fallback: 'Box Office Manager',
      },
      {
        term: 'SimpleOnboarding.Role_FloorSupervisor',
        fallback: 'Floor supervisor',
      },
      {term: 'SimpleOnboarding.Role_Cleaner', fallback: 'Cleaner'},
      {
        term: 'SimpleOnboarding.Role_EventCoordinator',
        fallback: 'Event coordinator',
      },
    ],
  },
  {
    industry: 'Fitness & Leisure',
    groups: [
      {
        term: 'SimpleOnboarding.Role_FitnessInstructor',
        fallback: 'Fitness instructor',
      },
      {
        term: 'SimpleOnboarding.Role_PersonalTrainer',
        fallback: 'Personal trainer',
      },
      {
        term: 'SimpleOnboarding.Role_SwimmingInstructor',
        fallback: 'Swimming instructor',
      },
      {
        term: 'SimpleOnboarding.Role_FacilityManager',
        fallback: 'Facility Manager',
      },
      {term: 'SimpleOnboarding.Role_FrontDesk', fallback: 'Front Desk'},
      {
        term: 'SimpleOnboarding.Role_MaintenanceStaff',
        fallback: 'Maintenance staff',
      },
      {term: 'SimpleOnboarding.Role_Receptionist', fallback: 'Receptionist'},
      {
        term: 'SimpleOnboarding.Role_MassageTherapist',
        fallback: 'Massage Therapist',
      },
    ],
  },
  {
    industry: 'Healthcare',
    groups: [
      {term: 'SimpleOnboarding.Role_Nurse', fallback: 'Nurse'},
      {term: 'SimpleOnboarding.Role_SeniorCarer', fallback: 'Senior Carer'},
      {term: 'SimpleOnboarding.Role_SupportWorker', fallback: 'Support worker'},
      {
        term: 'SimpleOnboarding.Role_RegisteredNurse',
        fallback: 'Registered Nurse',
      },
      {term: 'SimpleOnboarding.Role_Pharmacist', fallback: 'Pharmacist'},
      {term: 'SimpleOnboarding.Role_Caregiver', fallback: 'Caregiver'},
      {
        term: 'SimpleOnboarding.Role_MedicalAssistant',
        fallback: 'Medical assistant',
      },
    ],
  },
  {
    industry: 'Hotels',
    groups: [
      {term: 'SimpleOnboarding.Role_Receptionist', fallback: 'Receptionist'},
      {term: 'SimpleOnboarding.Role_Housekeeping', fallback: 'Housekeeping'},
      {term: 'SimpleOnboarding.Role_Waiter', fallback: 'Waiter'},
      {term: 'SimpleOnboarding.Role_Bartender', fallback: 'Bartender'},
      {term: 'SimpleOnboarding.Role_Concierge', fallback: 'Concierge'},
    ],
  },
  {
    industry: 'Retail & Bakery',
    groups: [
      {term: 'SimpleOnboarding.Role_Cashier', fallback: 'Cashier'},
      {term: 'SimpleOnboarding.Role_SalesAdvisor', fallback: 'Sales advisor'},
      {
        term: 'SimpleOnboarding.Role_RetailStoreManager',
        fallback: 'Retail Store Manager',
      },
      {term: 'SimpleOnboarding.Role_SalesClerk', fallback: 'Sales Clerk'},
      {
        term: 'SimpleOnboarding.Role_RetailAssistantManager',
        fallback: 'Retail Assistant Manager',
      },
      {term: 'SimpleOnboarding.Role_Inventory', fallback: 'Inventory'},
      {term: 'SimpleOnboarding.Role_Warehouse', fallback: 'Warehouse'},
    ],
  },
  {
    industry: 'Security & Services',
    groups: [
      {term: 'SimpleOnboarding.Role_TeamLeader', fallback: 'Team Leader'},
      {term: 'SimpleOnboarding.Role_Manager', fallback: 'Manager'},
    ],
  },
  {
    industry: 'Other',
    groups: [
      {term: 'SimpleOnboarding.Role_TeamLeader', fallback: 'Team Leader'},
      {term: 'SimpleOnboarding.Role_Manager', fallback: 'Manager'},
    ],
  },
];
